import React, { useMemo, useState } from "react";
import DataTable from "../../components/common/DataTable/DataTable";
import Spinner from "../common/spinner";
import moment from "moment";
import Modal from "../../components/common/modal";

const SharedCoupons = ({ data, isFetching, error }) => {
  const [show, setShow] = useState(false);
  const [selectedCoupon, setselectedCoupon] = useState([]);
  const handleClose = () => {
    setShow(false);
    setselectedCoupon([]);
  };
  const handleShow = () => setShow(true);

  const columns = useMemo(
    () => [
      {
        Header: "Date and Time",
        accessor: (row) => (
          <div className="date-time date-time-font-style">
            {moment(row.last_shared_on).format("MMM DD, YYYY")}{" "}
            <span>{moment(row.last_shared_on).format("hh:mm a")}</span>
          </div>
        ),
      },
      {
        Header: "Coupon Code",
        accessor: (row) => <strong>{row.coupon_code}</strong>,
      },
      {
        Header: "Short Description",
        accessor: "short_description",
      },
      {
        Header: "Shared Count",
        accessor: (row) => `${row?.patient_info?.length || "N/A"} Shared`,
      },
      {
        Header: "Actions",
        accessor: (row) => (
          <button
            className="rounded-pill secondary-button"
            style={{ pointerEvents: "initial" }}
            onClick={() => {
              handleShow();
              setselectedCoupon(row?.patient_info);
            }}
          >
            <i className="fa fa-eye" aria-hidden="true"></i>View
          </button>
        ),
      },
    ],
    []
  );
  if (isFetching) return <Spinner />;
  return (
    <>
      <DataTable columns={columns} data={data?.shared_coupon_detail || []} />
      <Modal
        show={show}
        onHide={handleClose}
        title={"Shared with"}
        className="custom-modal share-with-modal"
      >
        <div className="scroll-data">
          {selectedCoupon.length
            ? selectedCoupon.map((item, index) => (
                <>
                  <div className="modal-inner">
                    <div className="name-gmail mb-3" key={index}>
                      <h6
                        className="text-dark"
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        {item.patient_name}
                      </h6>
                      <p>
                        {item.patient_email && item.patient_phone
                          ? item.patient_email + " , " + item.patient_phone
                          : item.patient_email
                          ? item.patient_email
                          : item.patient_phone
                          ? item.patient_phone
                          : ""}
                      </p>
                    </div>
                  </div>
                </>
              ))
            : null}
        </div>
        <button
          className="primary-cta-button rounded-pill py-2 mt-3"
          onClick={handleClose}
        >
          Okay
        </button>
      </Modal>
    </>
  );
};

export default SharedCoupons;
